export default "__VITE_ASSET__J5I87nAD__"